export let registerExecution = {
  bindings: {
    activity: '<'
  },
  template: `
    <span
      ng-click="vm.registerExecution(vm.activity)" 
      class="text-gris-dark icon i-20 {{ vm.edit }} pointer">
    </span>`,
  controllerAs: 'vm',
  controller: ['$scope', 'WorkPlanModalSrv', 'CssClasses', 'GlobalSrv',
  function registerExecutionCtrl ($scope, WorkPlanModalSrv, CssClasses, GlobalSrv) {
  // constants
    const vm = this
    const icons = CssClasses.icons
    vm.edit = icons.edit
  // methods
    vm.registerExecution = registerExecution

    function registerExecution (activity) {
      let parentActivity = activity
      parentActivity.selectedActivityId = activity
      WorkPlanModalSrv.setVariable(parentActivity)
      WorkPlanModalSrv.registerExecution().then((promise) => {
        $scope.$emit('changeHoursExecuted', WorkPlanModalSrv.getVariable())
      })
    }
  }
]}




// WEBPACK FOOTER //
// ./src/app/u-faculty/components/activities-review/modals/register-execution.js